import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const csmExperiencesRoute: InvariantJiraRoute = {
	exact: true,
	name: 'csm-experiences',
	path: '/jira/customer-service-management/experiences',
};
